import CentralInvestorInformation from "./CentralInvestorInformation";
import { FBDate, InterestRate } from "./Globals";
import { TranslatedContent } from "./Language";
import ProjectContent, { NonLocalizedContent } from "./ProjectContent"

export type ProjectId = string
export type CoveragePercentage = number

export type Finance = {
    currentFunding: number;
    targetFunding: number;
    minimumInvestment: number;
    interestRate: InterestRate;
    coveragePercentage: CoveragePercentage;
    durationMax: number;
    durationMin: number;
    deadline?: FBDate;
}

export enum ProjectForcedStates {
    HIDDEN = "HIDDEN", COMMING_SOON = "COMMING_SOON", FAILED = "FAILED",
    FAILD_PROCESS = "FAILD_PROCESS"
}

export type ProjectState = {
    forcedState?: ProjectForcedStates;
    interestStartDate?: FBDate;
    interestEndDate?: FBDate;
    projectDeadline?: FBDate;
}

export type ProjectTitle = TranslatedContent
export type Teaser = TranslatedContent

type Image = string

export type Documentation = {
    projectInformationDocument?: string;
    centralInvestorInformation?: CentralInvestorInformation
}

export type Morarente = {
    startDate: FBDate;
    endDate?: FBDate;
}

export type FaildData = {
    paidBackTotalAmount: number
}

export type Project = {
    projectId: ProjectId;
    projectTitle: ProjectTitle;
    projectTeaser: Teaser;
    images: Image[];
    projectCreated: FBDate;
    state: ProjectState;
    finance: Finance;
    nonLocalizedContent?: NonLocalizedContent;
    localizedContent?: ProjectContent;
    documentation?: Documentation;
    morarente?: Morarente;
    faildData?: FaildData
}

export type GroupedProjects = { active: Project[], commingSoon: Project[], inProgress: Project[], completed: Project[] }

export default Project